export default __webpack_public_path__ + "static/media/logo-smart.f8768d67.png";